export const trnTypes = {
  SALES: "SAL",
  SALES_ORDER: "SLO",
  SALES_CHALLAN: "SLC",
  SALES_RETURN_CHALLAN: "RSLC",
  SALES_RETURN: "RSL",
  EXCESS_SALES_RETURN: "XRSL",
  SALES_CREDIT_NOTE: "SCN",
  SALES_DEBIT_NOTE: "SDN",
  QUICK_SALES: "QSAL",
  PURCHASE: "PUR",
  GENERAL_PURCHASE: "GPUR",
  PURCHASE_ORDER: "PUO",
  PURCHASE_CHALLAN: "PRC",
  PURCHASE_RETURN_CHALLAN: "RPUC",
  PURCHASE_RETURN: "RPU",
  PURCHASE_CREDIT_NOTE: "PCN",
  PURCHASE_DEBIT_NOTE: "PDN",
  QUICK_PURCHASE: "QPUR",
  RECEIPT_ENTRY: "RCP",
  PAYMENT_ENTRY: "PYM",
  CHEQUE_RETURN_ENTRY: "RCQ",
  JOURNAL_ENTRY: "JRN",
  CONTRA_ENTRY: "CTR",
  MILL_ISSUE: "GIS",
  MILL_RECEIVE: "PRO",
  CUTTING: "CIS",
  AUTO_CUTTING: "ACI",
  JOB_WORK_ISSUE: "JIS",
  JOB_WORK_RECEIVE_CHALLAN: "JRC",
  JOB_WORK_RECEIVE: "PJW",
  JOB_WORK_INWARD: "JIN",
  JOB_WORK_OUTWARD: "JOU",
  STOCK_INWARD_ENTRY: "STI",
  STOCK_OUTWARD_ENTRY: "STO",
  STOCK_MOVEMENT_ENTRY: "STM",
  STOCK_ASSEMBLY_ENTRY: "STA",
  AGENCY_PURCHASE: "APUR",
  AGENCY_PURCHASE_ORDER: "APUO",
  AGENCY_PURCHASE_RETURN: "ARPU",
  AGENCY_PAYMENT: "APYM",
  AGENCY_CHEQUE_RETURN_ENTRY: "ARCQ",
  AGENCY_DISPATCH_LETTER: "ADSL",
  COURIER: "COU",
  BANK_RECONCILIATION_RECEIPT: "BRCR",
  BANK_RECONCILIATION_PAYMENT: "BRCP",
};

export const trnTypeNames = [
  { id: trnTypes.SALES, name: "Sales" },
  { id: trnTypes.SALES_ORDER, name: "Sales Order" },
  { id: trnTypes.SALES_CHALLAN, name: "Sales Challan" },
  { id: trnTypes.SALES_RETURN_CHALLAN, name: "Sales Return Challan" },
  { id: trnTypes.SALES_RETURN, name: "Sales Return" },
  { id: trnTypes.EXCESS_SALES_RETURN, name: "Excess RG" },
  { id: trnTypes.PURCHASE, name: "Purchase" },
  { id: trnTypes.PURCHASE_ORDER, name: "Purchase Order" },
  { id: trnTypes.PURCHASE_CHALLAN, name: "Purchase Challan" },
  { id: trnTypes.PURCHASE_RETURN_CHALLAN, name: "Purchase Return Challan" },
  { id: trnTypes.PURCHASE_RETURN, name: "Purchase Return" },
  { id: trnTypes.SALES_CREDIT_NOTE, name: "Sales Credit Note" },
  { id: trnTypes.SALES_DEBIT_NOTE, name: "Sales Debit Note" },
  { id: trnTypes.PURCHASE_CREDIT_NOTE, name: "Purchase Credit Note" },
  { id: trnTypes.PURCHASE_DEBIT_NOTE, name: "Purchase Debit Note" },
  { id: trnTypes.GENERAL_PURCHASE, name: "General Purchase" },
  { id: trnTypes.QUICK_SALES, name: "Quick Sales" },
  { id: trnTypes.QUICK_PURCHASE, name: "Quick Purchase" },
  { id: trnTypes.RECEIPT_ENTRY, name: "Receipt Entry" },
  { id: trnTypes.PAYMENT_ENTRY, name: "Payment Entry" },
  { id: trnTypes.CHEQUE_RETURN_ENTRY, name: "Cheque Return Entry" },
  { id: trnTypes.JOURNAL_ENTRY, name: "Journal Entry" },
  { id: trnTypes.CONTRA_ENTRY, name: "Credit Transfer Entry" },
  { id: trnTypes.MILL_ISSUE, name: "Mill Issue" },
  { id: trnTypes.MILL_RECEIVE, name: "Mill Receive" },
  { id: trnTypes.CUTTING, name: "Cutting" },
  { id: trnTypes.JOB_WORK_ISSUE, name: "Job Issue" },
  { id: trnTypes.JOB_WORK_RECEIVE_CHALLAN, name: "Job Receive Challan" },
  { id: trnTypes.JOB_WORK_INWARD, name: "Job Inward" },
  { id: trnTypes.JOB_WORK_OUTWARD, name: "Job Outward" },
  { id: trnTypes.JOB_WORK_RECEIVE, name: "Job Receive Bill" },
  { id: trnTypes.STOCK_INWARD_ENTRY, name: "Stock Inward" },
  { id: trnTypes.STOCK_OUTWARD_ENTRY, name: "Stock Outward" },
  { id: trnTypes.STOCK_ASSEMBLY_ENTRY, name: "Stock Assembly" },
  { id: trnTypes.STOCK_MOVEMENT_ENTRY, name: "Stock Movement" },
  { id: trnTypes.AGENCY_PURCHASE, name: "Agency Purchase" },
  { id: trnTypes.AGENCY_PURCHASE_ORDER, name: "Agency Purchase Order" },
  { id: trnTypes.AGENCY_PURCHASE_RETURN, name: "Agency Purchase Return" },
  { id: trnTypes.AGENCY_PAYMENT, name: "Agency Payment" },
  { id: trnTypes.AGENCY_CHEQUE_RETURN_ENTRY, name: "Agency Cheque Return Entry" },
  { id: trnTypes.AGENCY_DISPATCH_LETTER, name: "Agency Dispatch Letter" },
  { id: trnTypes.COURIER, name: "Courier" },
];

export const allTrnTypeNames = [...trnTypeNames, { id: trnTypes.AUTO_CUTTING, name: "Auto Cutting" }];

export const getTrnTypesForIndustry = (industry, orgSettings) => {
  return trnTypeNames.filter(obj => {
    switch (obj.id) {
      case trnTypes.MILL_ISSUE:
      case trnTypes.MILL_RECEIVE:
      case trnTypes.CUTTING: {
        return industry === "Textile" || industry === "Weaving";
      }
      case trnTypes.JOB_WORK_ISSUE:
      case trnTypes.JOB_WORK_RECEIVE:
      case trnTypes.JOB_WORK_RECEIVE_CHALLAN: {
        return industry === "Textile" || industry === "Weaving" || orgSettings?.modules?.externalJobwork?.enabled
      }
      case trnTypes.JOB_WORK_INWARD:
      case trnTypes.JOB_WORK_OUTWARD: {
        return industry === "Jobwork" || orgSettings?.modules?.internalJobwork?.enabled
      }
      case trnTypes.AGENCY_PURCHASE_ORDER:
      case trnTypes.AGENCY_PURCHASE:
      case trnTypes.AGENCY_PURCHASE_RETURN:
      case trnTypes.AGENCY_DISPATCH_LETTER:
      case trnTypes.AGENCY_PAYMENT:
      case trnTypes.AGENCY_CHEQUE_RETURN_ENTRY: {
        return industry === "Agency"
      }
      default: {
        return true
      }
    }
  }).sort((a, b) => a.name < b.name ? -1 : 1)
}

export const invoiceTypes = [
  { id: "TAX", name: "Tax Invoice" },
  { id: "NOTAX", name: "No Tax" },
  { id: "DEEMED EXPORT", name: "Deemed Export" },
  { id: "EXPWP", name: "Export With Tax" },
  { id: "EXPWOP", name: "Export Without Tax" },
  { id: "SEZWP", name: "SEZ With Tax" },
  { id: "SEZWOP", name: "SEZ Without Tax" },
];

export const gstNatures = [
  { id: "Regular", name: "Regular" },
  { id: "Composition", name: "Composition" },
  { id: "EXPORTER", name: "Exporter" },
  { id: "EXPORT", name: "Direct Export" },
  { id: "SEZ Unit", name: "SEZ Unit" },
  { id: "SEZ Developer", name: "SEZ Developer" },
  { id: "UNREGISTERED", name: "Unregistered" },
];

export const getBackendUrl = () =>
  process.env.NODE_ENV === "production" ? "/api" : (process.env.REACT_APP_BACKEND_URL || "http://localhost:80/api");

export const getDefaultLotSize = () => 12;

export const unitQuantityCodes = [
  "BAG-BAGS",
  "BAL-BALE",
  "BDL-BUNDLES",
  "BKL-BUCKLES",
  "BOU-BILLION OF UNITS",
  "BOX-BOX",
  "BTL-BOTTLES",
  "BUN-BUNCHES",
  "CAN-CANS",
  "CBM-CUBIC METERS",
  "CCM-CUBIC CENTIMETERS",
  "CMS-CENTIMETERS",
  "CTN-CARTONS",
  "DOZ-DOZENS",
  "DRM-DRUMS",
  "GGK-GREAT GROSS",
  "GMS-GRAMMES",
  "GRS-GROSS",
  "GYD-GROSS YARDS",
  "KGS-KILOGRAMS",
  "KLR-KILOLITRE",
  "KME-KILOMETRE",
  "LTR-LITRES",
  "MLT-MILILITRE",
  "MTR-METERS",
  "MTS-METRIC TON",
  "NOS-NUMBERS",
  "PAC-PACKS",
  "PCS-PIECES",
  "PRS-PAIRS",
  "QTL-QUINTAL",
  "ROL-ROLLS",
  "SET-SETS",
  "SQF-SQUARE FEET",
  "SQM-SQUARE METERS",
  "SQY-SQUARE YARDS",
  "TBS-TABLETS",
  "TGM-TEN GROSS",
  "THD-THOUSANDS",
  "TON-TONNES",
  "TUB-TUBES",
  "UGS-US GALLONS",
  "UNT-UNITS",
  "YDS-YARDS",
  "OTH-OTHERS",
];

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const quarters = [
  "January - March",
  "April - June",
  "July - September",
  "October - December",
];

export const companyTypes = [
  "Sole Proprietorship",
  "Partnership",
  "Limited Liability Partnership",
  "Private Limited",
];

export const userOrgRoles = {
  OWNER: "owner",
  USER: "user",
};

export const fontFamilies = [
  "Arial",
  "Times New Roman",
  "Verdana",
  "Roboto",
  "Noto Sans",
  "Noto Serif",
  "Courier Prime",
  "Source Code Pro",
  "Montserrat",
]

export const industryTypes = [
  { label: "Textile", value: "Textile" },
  { label: "Weaving", value: "Weaving" },
  { label: "Jobwork", value: "Jobwork" },
  { label: "Agency", value: "Agency" },
  { label: "Aadat", value: "Aadat" },
  { label: "Standard", value: "Standard" },
]